import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import InputAdornment from "@mui/material/InputAdornment";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import EmailIcon from "@mui/icons-material/Email";
import EventIcon from "@mui/icons-material/Event";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import axios from "axios";
import { apiRequest } from "../../api/apiHelper";
import Toast from "../../components/Toast";
import useToast from "../../hooks/useToast";
import { useLocation, useNavigate } from "react-router-dom";
import gmailicon from "../../assets/onboarding/gmail.png";
import calendaricon from "../../assets/onboarding/calendar.png";
const steps = ["Personal & Company Details", "Team setup", "Connect Services"];

const designations = ["Manager", "Team Member"];

// const industries = [
//   "Technology",
//   "Healthcare",
//   "Finance",
//   "Education",
//   "Manufacturing",
//   "Retail",
// ];
const industries = [
  "Technology",
  "Healthcare",
  "Finance",
  "Education",
  "Manufacturing",
  "Retail",
  "Telecommunications",
  "Energy",
  "Transportation",
  "Hospitality",
  "Entertainment",
  "Real Estate",
  "Agriculture",
  "Pharmaceuticals",
  "Automotive",
  "Aerospace",
  "Food & Beverage",
  "Media & Publishing",
  "Consulting",
  "Nonprofit",
  "Insurance",
  "Construction",
  "Logistics",
  "E-commerce",
];

const companySizes = ["1", "2-5", "6-10", "11-50", "50+"];

const screenStyle = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  // background: "#f7f9fc",
};

const formBoxStyle = {
  width: "100%",
  // bgcolor: "background.paper",
  borderRadius: 2,
  // boxShadow: 24,
  p: 4,
  outline: "none",
};

const formContentStyle = {
  width: "50%",
  maxWidth: "800px",
  minWidth: "400px",
  margin: "0 auto",
};

export default function Onboarding() {
  const { toast, success, error, hideToast } = useToast();
  const [activeStep, setActiveStep] = useState(0);
  const {
    name,
    email,
    id: userId,
    role: rl,
  } = JSON.parse(localStorage.getItem("userData"));
  // Step 0 (Combined: Personal & Company Details)
  const [designation, setDesignation] = useState(""); // Combined role and job title
  const [yourName, setYourName] = useState(name);
  const [phoneNumber, setPhoneNumber] = useState("91");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [industry, setIndustry] = useState("");

  // Step 3 (Team setup)
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteList, setInviteList] = useState([]);
  const [inviteError, setInviteError] = useState("");
  const [invitesSent, setInvitesSent] = useState(false);
  const [teamSetupSkipped, setTeamSetupSkipped] = useState(false);
  const [inviteStatuses, setInviteStatuses] = useState({});
  // Step 4 (Connect Services)
  const [gmailConnected, setGmailConnected] = useState(false);
  const [calendarConnected, setCalendarConnected] = useState(false);

  const [isLoadingUser, setIsLoadingUser] = useState(false);
  const [isLoadingOrg, setIsLoadingOrg] = useState(false);
  const [isConnectingService, setIsConnectingService] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const returnTo = params.get("state");
  const tokenFromUrl = params.get("token");      // 📌 NEW: Capture token from OAuth callback
  const userIdFromUrl = params.get("userId");    // 📌 NEW: Capture userId from OAuth callback
  const nameFromUrl = params.get("name");        // 📌 NEW: Capture name from OAuth callback
  const emailFromUrl = params.get("email");      // 📌 NEW: Capture email from OAuth callback

  const orgId = localStorage.getItem("orgId");
  // Step 0 validation (Combined: Personal & Company Details)
  const step0Valid =
    rl === "member"
      ? designation && yourName && phoneNumber && phoneNumber.length > 5
      : designation &&
      yourName &&
      phoneNumber && phoneNumber.length > 5 &&
      companyName &&
      companySize &&
      industry;
  // Step 1 validation (Team setup) - Allow skipping for managers
  const step1Valid =
    designation === "Team Member" ||
    (designation === "Manager" &&
      (inviteList.length > 0 || invitesSent || teamSetupSkipped));
  // Step 2 validation (Connect Services)
  const step2Valid = gmailConnected && calendarConnected;

  const handleNext = async () => {
    if (activeStep === 0 && !step0Valid) return;
    if (activeStep === 1 && !step1Valid) return;
    if (activeStep === 2 && !step2Valid) return;

    // Step 0: Update user details AND create/update organization
    if (activeStep === 0) {
      if (!phoneNumber || phoneNumber.length <= 5) {
        error("Please enter a valid phone number.", { title: "Phone Required" });
        return;
      }
      setIsLoadingUser(true);
      setIsLoadingOrg(true);

      try {
        // Determine role based on designation
        // const role = designation === "Manager" ? "manager" : "member";

        // Update user details
        await apiRequest("patch", `/user-update/${userId}`, {
          phoneNumber,
          name: yourName,
          role: rl,
        });

        // Only create/update organization if user is not a member
        if (rl !== "member") {
          // Create or update organization
          const oId = localStorage.getItem("orgId");
          if (oId && oId !== "null" && oId !== "undefined") {
            await apiRequest("patch", "/organization/update/" + oId, {
              company_name: companyName,
              size: companySize,
              sector: industry,
            });
          } else {
            await apiRequest("post", "/organization/create", {
              company_name: companyName,
              size: companySize,
              sector: industry,
            });
          }
        }
        success(
          rl === "member"
            ? "Personal details updated successfully"
            : "Personal and company details updated successfully",
          {
            title: "Success",
          }
        );
      } catch (err) {
        if (err.response_code === 422) {
          error("User not found.", { title: "Update Failed" });
        } else if (err.response_code === 409) {
          error("Organization already exists.", { title: "Creation Failed" });
        } else if (err.isNetworkError) {
          error("Network error. Please check your connection.", {
            title: "Connection Error",
          });
        } else {
          error(err.message || "Failed to update details", {
            title: "Error",
          });
        }
        setIsLoadingUser(false);
        setIsLoadingOrg(false);
        return;
      } finally {
        setIsLoadingUser(false);
        setIsLoadingOrg(false);
      }
    }

    setActiveStep((prev) => prev + 1);
  };
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleAddInvite = () => {
    if (!inviteEmail || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inviteEmail)) {
      setInviteError("Enter a valid email");
      return;
    }
    if (inviteList.includes(inviteEmail)) {
      setInviteError("Already added");
      return;
    }
    setInviteList([...inviteList, inviteEmail]);
    setInviteEmail("");
    setInviteError("");
  };

  const handleDeleteInvite = (email) => {
    setInviteList(inviteList.filter((e) => e !== email));
  };

  const handleSendInvites = async () => {
    if (inviteList.length === 0) {
      setInviteError("Please add at least one email to invite");
      return;
    }

    setIsConnectingService(true);
    setInviteError("");

    try {
      const response = await apiRequest("post", "/invite/sendInvite", {
        emails: inviteList,
        role: "member",
      });

      console.log("Invite API response:", response);
      console.log("Response type:", typeof response);
      console.log("Response keys:", Object.keys(response));
      console.log("Has results property:", response.hasOwnProperty("results"));
      console.log("Results is array:", Array.isArray(response.results));

      // Handle different possible response structures
      let results = null;

      if (response.results && Array.isArray(response.results)) {
        results = response.results;
      } else if (
        response.data &&
        response.data.results &&
        Array.isArray(response.data.results)
      ) {
        results = response.data.results;
      } else if (Array.isArray(response)) {
        results = response;
      } else if (response.data && Array.isArray(response.data)) {
        results = response.data;
      }

      console.log("Extracted results:", results);

      if (results && Array.isArray(results)) {
        setInvitesSent(true);

        // Store invite statuses for each email
        const statusMap = {};
        results.forEach((result) => {
          statusMap[result.email] = result.status;
        });
        setInviteStatuses(statusMap);

        // Count successful invites
        const successfulInvites = results.filter(
          (result) => result.status === "invited"
        );
        const failedInvites = results.filter(
          (result) => result.status !== "invited"
        );

        if (successfulInvites.length > 0) {
          success(
            `Successfully invited ${successfulInvites.length} team member(s)!`,
            {
              title: "Invites Sent",
            }
          );
        }

        if (failedInvites.length > 0) {
          error(
            `Failed to invite ${failedInvites.length} team member(s). Please try again.`,
            {
              title: "Some Invites Failed",
            }
          );
        }

        // Log individual invite results for debugging
        results.forEach((result) => {
          console.log(`Email ${result.email}: ${result.status}`);
        });
      } else {
        console.log("No valid results found in response");
        console.log(
          "Full response structure:",
          JSON.stringify(response, null, 2)
        );
        error("Failed to send invites. Please try again.", {
          title: "Invite Error",
        });
      }
    } catch (err) {
      console.error("Error sending invites:", err);

      if (err.response_code === 400) {
        error("Invalid email addresses. Please check and try again.", {
          title: "Invalid Emails",
        });
      } else if (err.response_code === 422) {
        error("Some emails are invalid. Please check and try again.", {
          title: "Validation Error",
        });
      } else if (err.isNetworkError) {
        error("Network error. Please check your connection and try again.", {
          title: "Connection Error",
        });
      } else if (err.response && err.response.data) {
        // Handle partial success/failure from API
        const response = err.response.data;

        // Try to extract results from different possible structures
        let results = null;

        if (response.results && Array.isArray(response.results)) {
          results = response.results;
        } else if (
          response.data &&
          response.data.results &&
          Array.isArray(response.data.results)
        ) {
          results = response.data.results;
        } else if (Array.isArray(response)) {
          results = response;
        } else if (response.data && Array.isArray(response.data)) {
          results = response.data;
        }

        if (results && Array.isArray(results)) {
          // Store invite statuses for each email
          const statusMap = {};
          results.forEach((result) => {
            statusMap[result.email] = result.status;
          });
          setInviteStatuses(statusMap);

          const successfulInvites = results.filter(
            (result) => result.status === "invited"
          );
          const failedInvites = results.filter(
            (result) => result.status !== "invited"
          );

          if (successfulInvites.length > 0) {
            success(
              `Successfully invited ${successfulInvites.length} team member(s)!`,
              {
                title: "Partial Success",
              }
            );
          }

          if (failedInvites.length > 0) {
            error(
              `Failed to invite ${failedInvites.length} team member(s). Please check the email addresses and try again.`,
              {
                title: "Some Invites Failed",
              }
            );
          }
        } else {
          console.log("No valid results found in error response");
          console.log(
            "Error response structure:",
            JSON.stringify(response, null, 2)
          );
          error(err.message || "Failed to send invites. Please try again.", {
            title: "Invite Error",
          });
        }
      } else {
        error(err.message || "Failed to send invites. Please try again.", {
          title: "Invite Error",
        });
      }
    } finally {
      setIsConnectingService(false);
    }
  };

  const handleSkipTeamSetup = () => {
    setTeamSetupSkipped(true);
    setActiveStep((prev) => prev + 1);
  };

  // const login = useGoogleLogin({
  //   prompt: "consent",
  //   access_type: "offline",
  //   scope:
  //     "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/calendar",
  //   onSuccess: async (tokenResponse) => {
  //     console.log(tokenResponse);
  //     const accessToken = tokenResponse.access_token;

  //     try {
  //       // Example: Read Gmail Labels
  //       const res = await axios.get(
  //         "https://gmail.googleapis.com/gmail/v1/users/me/labels",
  //         {
  //           headers: { Authorization: `Bearer ${accessToken}` },
  //         }
  //       );
  //       console.log(res.data);
  //       setGmailConnected(true);
  //       success("Gmail connected successfully!", { title: "Success" });
  //     } catch (err) {
  //       console.error("Gmail API error:", err);
  //       error("Failed to connect Gmail. Please try again.", {
  //         title: "Connection Error",
  //       });
  //     }
  //   },
  //   onError: () => {
  //     console.log("Login Failed");
  //     error("Google login failed. Please try again.", { title: "Login Error" });
  //   },
  // });

  // const CLIENT_ID =
  //   "283556775570-itlqv5m6c3b0a5f6hti612bk4gb0vfp5.apps.googleusercontent.com";
  // const REDIRECT_URI = "http://localhost:3000/onboarding";
  // const SCOPE =
  //     "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.email";

  // const handleLogin = () => {
  //   const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${encodeURIComponent(
  //     scopesMap.calendar.join(" ")
  //   )&access_type=offline&prompt=consent`;

  //   console.log("Redirecting to Google OAuth URL:", url);
  //   window.location.href = url;
  // };

  const handleConnectService = (service) => {
    if (isConnectingService) return; // Prevent multiple clicks

    console.log(`Attempting to connect ${service}...`);
    setIsConnectingService(true);

    // Use the same approach as Notes.jsx - redirect to the Gmail login endpoint
    const url = process.env.REACT_APP_API_BASE_URL + "/gmail/login";
    console.log(`Redirecting to Gmail login URL for ${service}:`, url);
    window.location.href = url;
  };

  const checkServiceConnection = async () => {
    try {
      // Check both Gmail and Calendar connection status from same endpoint
      const response = await apiRequest("get", `/gmail/checkToken`);
      console.log("Service connection check response:", response);

      if (response) {
        // Update Gmail connection status based on backend response format
        if (response.gmail === true) {
          setGmailConnected(true);
        }

        // Update Calendar connection status based on backend response format
        if (response.calendar === true) {
          setCalendarConnected(true);
        }
      }
    } catch (error) {
      console.log("Error checking service connections:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check sessionStorage immediately
    const selectedPlan = sessionStorage.getItem("selectedPlan");
    console.log("=== ONBOARDING SUBMIT ===");
    console.log("Selected plan from sessionStorage:", selectedPlan);
    console.log("All sessionStorage keys:", Object.keys(sessionStorage));

    success("Onboarding completed successfully!", { title: "Welcome!" });

    // Immediate redirect without timeout
    if (selectedPlan) {
      const planDetails = JSON.parse(selectedPlan);
      console.log("Plan details found:", planDetails);
      // Redirect to billing with plan details
      const billingUrl = `/home/settings/billing?planId=${planDetails.planId}&planName=${encodeURIComponent(planDetails.planName)}&pricePerUser=${planDetails.pricePerUser}&billingCycle=${planDetails.billingCycle}`;
      console.log("Redirecting to billing URL:", billingUrl);
      navigate(billingUrl, { replace: true });
    } else {
      console.log("No plan selected, redirecting to home page");
      navigate("/home", { replace: true });
    }
  };

  const getOrgDetails = async () => {
    try {
      const data = await apiRequest("get", `/organization/get/${orgId}`);
      console.log("data:org ", data);
      setCompanyName(data.organization.company_name);
      setCompanySize(data.organization.size);
      setIndustry(data.organization.sector);
    } catch (error) { }
  };

  const getUserDetails = async () => {
    try {
      const data = await apiRequest("get", `/user/${userId}`);
      console.log("data:user on onboarding time ....................", data);
      const {
        email,
        phoneNumber: phN,
        role: rl,
        name: n,
        organizationId: organization,
      } = data.data;
      // Convert role to designation
      setDesignation(rl === "manager" ? "Manager" : "Team Member");
      // Only set phone number if it exists from API, otherwise keep default
      if (phN) {
        setPhoneNumber(phN);
      }
      console.log("n: ", n);
      console.log("phN: ", phN);
      console.log("orgId", organization);

      if (phN && n && organization != null) {
        localStorage.setItem("orgId", organization);
        setActiveStep(1); // Skip to team setup if user and org details exist
      }
    } catch (error) { }
  };

  const handleUpdateOrg = () => { };

  useEffect(() => {
    if (orgId != "") {
      getOrgDetails();
    }
    getUserDetails();
    checkServiceConnection(); // Check if services are already connected
  }, []);

  // 📌 NEW: Handle token from Google OAuth callback (Gmail reconnection flow)
  useEffect(() => {
    if (tokenFromUrl) {
      console.log("🔐 Token received from Google OAuth callback");
      console.log("📝 Storing token in localStorage...");
      
      // Store the new token
      localStorage.setItem("authToken", tokenFromUrl);
      
      // Update userData with new info if available
      if (userIdFromUrl || nameFromUrl || emailFromUrl) {
        const existingUserData = JSON.parse(localStorage.getItem("userData") || "{}");
        const updatedUserData = {
          ...existingUserData,
          id: userIdFromUrl || existingUserData.id,
          name: nameFromUrl || existingUserData.name,
          email: emailFromUrl || existingUserData.email,
        };
        localStorage.setItem("userData", JSON.stringify(updatedUserData));
        console.log("✅ Updated user data in localStorage");
      }
      
      // Clean URL without token parameter
      navigate(location.pathname, { replace: true });
      
      // Show success and redirect to home
      success("Gmail reconnected successfully!", { title: "Success" });
      setTimeout(() => {
        navigate("/home", { replace: true });
      }, 1500);
    }
  }, [tokenFromUrl, userIdFromUrl, nameFromUrl, emailFromUrl, navigate, location.pathname, success]);

  useEffect(() => {
    console.log("code: ", code);

    if (code) {
      // Call your API with the code
      const fetchData = async () => {
        try {
          // Since backend handles both Gmail and Calendar from same URL
          // console.log("this code from frontend :",code)

          const response = await apiRequest(
            "get",
            `/gmail/oauth2callback?code=${code}&state=both`
          );
          console.log("OAuth callback response:", response);

          // After OAuth callback, check the actual token status
          await checkServiceConnection();

          // Show success message
          success("Gmail and Calendar connected successfully!", {
            title: "Success",
          });
        } catch (error) {
          console.error("Error sending code to API:", error);
          error("Failed to connect service. Please try again.", {
            title: "Connection Error",
          });
        } finally {
          setIsConnectingService(false); // Reset loading state
          // After processing, navigate back if a return path was provided
          if (returnTo) {
            navigate(returnTo, { replace: true });
          } else {
            // Remove all URL params without reloading
            navigate(location.pathname, { replace: true });
          }
        }
      };

      fetchData();
    }
  }, [code, returnTo]);

  return (
    <div style={screenStyle}>
      <Toast
        open={toast.open}
        message={toast.message}
        severity={toast.severity}
        title={toast.title}
        duration={toast.duration}
        onClose={hideToast}
        position={toast.position}
      />
      <Box sx={formBoxStyle}>
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
          {steps.map((label, idx) => (
            <Step key={label} completed={activeStep > idx}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Box sx={formContentStyle}>
          <form onSubmit={handleSubmit}>
            {activeStep === 0 && (
              <>
                <Typography
                  variant="h5"
                  color="primary.main"
                  fontWeight={700}
                  align="center"
                  mb={1}
                >
                  Personal & Company Details
                </Typography>
                <Typography align="center" mb={3}>
                  Tell us about yourself and your company to get started.
                </Typography>

                <Typography align="center" mb={2}>
                  You're signing up as <b>{email}</b>
                </Typography>

                {rl === "member" && (
                  <Typography
                    align="center"
                    mb={2}
                    style={{
                      color: "#396afc",
                      fontWeight: 600,
                      background: "#f4f5fa",
                      padding: "8px 16px",
                      borderRadius: 8,
                      fontSize: "0.9rem",
                    }}
                  >
                    ℹ️ As a team member, you only need to provide your personal
                    details
                  </Typography>
                )}

                <FormControl fullWidth margin="normal" required>
                  <InputLabel>Designation</InputLabel>
                  <Select
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                    label="Designation"
                    disabled={rl === "member"}
                  >
                    {designations.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  label="Your name"
                  value={yourName}
                  onChange={(e) => setYourName(e.target.value)}
                  fullWidth
                  margin="normal"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">👤</InputAdornment>
                    ),
                  }}
                  required
                />

                <div style={{ margin: "16px 0 0 0" }}>
                  <PhoneInput
                    country="in"
                    value={phoneNumber}
                    onChange={setPhoneNumber}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    inputStyle={{
                      width: "100%",
                      borderRadius: 8,
                      fontSize: "1rem",
                      border: "1.5px solid #e0e7ef",
                    }}
                    containerStyle={{ width: "100%" }}
                    defaultCountry="in"
                    preferredCountries={["in", "us", "gb", "au", "ca"]}
                    priority={{ in: 0 }}
                    countryCodeEditable={false}
                    autoFormat={true}
                    enableSearch={true}
                    disableSearchIcon={false}
                  />
                </div>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  mt={1}
                  display="block"
                >
                  This may be used to contact you if you need assistance
                </Typography>

                <TextField
                  label="Company name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  fullWidth
                  margin="normal"
                  disabled={rl == "member"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">🏢</InputAdornment>
                    ),
                  }}
                  required
                />
                <FormControl fullWidth margin="normal" required>
                  <InputLabel>How big is your company?</InputLabel>
                  <Select
                    value={companySize}
                    onChange={(e) => setCompanySize(e.target.value)}
                    label="How big is your company?"
                    disabled={rl == "member"}
                  >
                    {companySizes.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth margin="normal" required>
                  <InputLabel>Company industry</InputLabel>
                  <Select
                    disabled={rl == "member"}
                    value={industry}
                    onChange={(e) => setIndustry(e.target.value)}
                    label="Company industry"
                  >
                    {industries.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}
            {activeStep === 1 && (
              <>
                <Typography
                  variant="h5"
                  color="primary.main"
                  fontWeight={700}
                  align="center"
                  mb={1}
                >
                  Team setup
                </Typography>
                <Typography align="center" mb={2}>
                  {designation === "Manager"
                    ? teamSetupSkipped
                      ? "Team setup skipped. You can invite members later from the dashboard."
                      : "Invite your team members to get started."
                    : "You're all set to join your team!"}
                </Typography>
                {designation === "Manager" && !teamSetupSkipped && (
                  <Box mb={2}>
                    <Typography fontWeight={600} mb={1}>
                      Invite your team members
                    </Typography>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      mb={1}
                    >
                      <TextField
                        label="Team member email"
                        value={inviteEmail}
                        onChange={(e) => setInviteEmail(e.target.value)}
                        size="small"
                        sx={{ flex: 1 }}
                        error={!!inviteError}
                        helperText={inviteError}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleAddInvite();
                          }
                        }}
                      />
                      <Button
                        variant="contained"
                        onClick={handleAddInvite}
                        sx={{ minWidth: 90 }}
                        disabled={
                          !inviteEmail ||
                          !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inviteEmail)
                        }
                      >
                        Add
                      </Button>
                    </Stack>
                    <Stack direction="row" spacing={1} flexWrap="wrap">
                      {inviteList.map((email) => {
                        const status = inviteStatuses[email];
                        const isInvited = status === "invited";
                        const isFailed = status && status !== "invited";

                        return (
                          <Chip
                            key={email}
                            label={`${email} ${isInvited ? "✓" : isFailed ? "✗" : ""
                              }`}
                            onDelete={() => handleDeleteInvite(email)}
                            color={
                              isInvited
                                ? "success"
                                : isFailed
                                  ? "error"
                                  : "primary"
                            }
                            variant={isInvited ? "filled" : "outlined"}
                            sx={{
                              mb: 1,
                              "& .MuiChip-label": {
                                fontSize: "0.8rem",
                              },
                            }}
                          />
                        );
                      })}
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={
                          inviteList.length === 0 || isConnectingService
                        }
                        onClick={handleSendInvites}
                        startIcon={
                          isConnectingService ? (
                            <CircularProgress size={16} />
                          ) : null
                        }
                      >
                        {isConnectingService
                          ? "Sending..."
                          : invitesSent
                            ? "Invites Sent"
                            : "Send Invites"}
                      </Button>
                      <Button
                        variant="outlined"
                        // color="secondary"
                        color="primary"
                        onClick={handleSkipTeamSetup}
                        disabled={isConnectingService}
                      >
                        Skip for now
                      </Button>
                    </Stack>
                    {invitesSent && (
                      <Typography
                        variant="body2"
                        color="success.main"
                        sx={{ mt: 1, textAlign: "center" }}
                      >
                        ✅ Invites have been sent successfully!
                      </Typography>
                    )}
                  </Box>
                )}
              </>
            )}
            {activeStep === 2 && (
              <>
                <Typography
                  variant="h5"
                  color="primary.main"
                  fontWeight={700}
                  align="center"
                  mb={1}
                >
                  Connect your services
                </Typography>
                <Typography align="center" mb={3}>
                  Connect your Google services to enable seamless integration.
                </Typography>
                <Stack spacing={3} maxWidth={500} mx="auto">
                  <Card
                    variant={gmailConnected ? "elevation" : "outlined"}
                    sx={{
                      border: gmailConnected
                        ? "2px solid #1976d2"
                        : "1px solid #e0e7ef",
                      background: gmailConnected ? "#f3f8ff" : "#fff",
                      cursor: gmailConnected ? "default" : "pointer",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        transform: gmailConnected ? "none" : "translateY(-2px)",
                        boxShadow: gmailConnected ? 4 : 2,
                      },
                    }}
                    onClick={() =>
                      !gmailConnected && handleConnectService("gmail")
                    }
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        py: 3,
                        px: 4,
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 3 }}
                      >
                        <Box
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: 2,
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isConnectingService && !gmailConnected ? (
                            <CircularProgress size={24} />
                          ) : (
                            <img
                              src={gmailicon}
                              alt="Gmail icon to connect your Gmail account"
                              style={{
                                width: 38,
                                height: 38,
                                objectFit: "contain",
                              }}
                            />
                          )}
                        </Box>
                        <Box>
                          <Typography fontWeight={700} variant="h6" mb={0.5}>
                            Gmail
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {gmailConnected
                              ? "Connected successfully"
                              : isConnectingService && !gmailConnected
                                ? "Connecting..."
                                : "Connect your Gmail account for email integration"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                  <Card
                    variant={calendarConnected ? "elevation" : "outlined"}
                    sx={{
                      border: calendarConnected
                        ? "2px solid #1976d2"
                        : "1px solid #e0e7ef",
                      background: calendarConnected ? "#f3f8ff" : "#fff",
                      cursor: calendarConnected ? "default" : "pointer",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        transform: calendarConnected
                          ? "none"
                          : "translateY(-2px)",
                        boxShadow: calendarConnected ? 4 : 2,
                      },
                    }}
                    onClick={() =>
                      !calendarConnected && handleConnectService("calendar")
                    }
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        py: 3,
                        px: 4,
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 3 }}
                      >
                        <Box
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: 2,
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isConnectingService && !calendarConnected ? (
                            <CircularProgress size={24} />
                          ) : (
                            <img
                              src={calendaricon}
                              alt="Google Calendar icon to connect your calendar"
                              style={{
                                width: 38,
                                height: 38,
                                objectFit: "contain",
                              }}
                            />
                          )}
                        </Box>
                        <Box>
                          <Typography fontWeight={700} variant="h6" mb={0.5}>
                            Google Calendar
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {calendarConnected
                              ? "Connected successfully"
                              : isConnectingService && !calendarConnected
                                ? "Connecting..."
                                : "Connect your Google Calendar for scheduling"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Stack>
              </>
            )}
            <Box display="flex" justifyContent="space-between" mt={3}>
              {activeStep > 0 ? (
                <Button onClick={handleBack} variant="outlined">
                  Back
                </Button>
              ) : (
                <div></div>
              )}
              {activeStep < steps.length - 1 && (
                <Button
                  onClick={handleNext}
                  variant="contained"
                  color="primary"
                  disabled={
                    isLoadingUser ||
                    isLoadingOrg ||
                    (activeStep === 0 && !step0Valid) ||
                    (activeStep === 1 && !step1Valid) ||
                    (activeStep === 2 && !step2Valid)
                  }
                >
                  Next
                </Button>
              )}
              {activeStep === steps.length - 1 && (
                <Button type="submit" variant="contained" color="primary">
                  Finish
                </Button>
              )}
            </Box>
          </form>
        </Box>
      </Box>
    </div>
  );
}
